import faceBoockIco from "../icons/faceIcon.svg";
import InstagramIco from "../icons/InstagramIcon.svg";
import whatsappIco from "../icons/whatsappIco.svg";
import { Link } from "react-router-dom";
import "../styles/footer.css";
export default function Footer() {
  const handleNumber = () => {
    alert("My Number : +201201076713")
  };
    return <>
    <section class="Conntect" id="Conntect">
      <ul>
        <li>
          <Link to="https://www.facebook.com/profile.php?id=100085773056004" target="_blank">
            <img src={ faceBoockIco } alt="" />
          </Link>
        </li>
        <li>
          <Link to="https://www.instagram.com/betooooi46/" target="_blank">
            <img src={ InstagramIco } alt="" />
          </Link>
        </li>
        <li>
          <div>
            <img id="whats" src={ whatsappIco } onClick={ handleNumber } alt="" />
          </div>
        </li>
      </ul>
    </section>
    <div className="myLink">
      <h4>
        Created By: 
        <Link to="https://yousefromany-dev-93bn.onrender.com/" className="Link" target="_blank">
          yousef Romany
        </Link>
      </h4>
    </div>
    </>;
};